<template>
  <div class="wrap talk">
    <div class="container">
      <main class="content" style="height: 100vh; overflow: scroll;">
        <article class="certification atm">
          <section>
            <div class="con-box">
              <div style="display: flex; justify-content: space-around; border-bottom: 1px solid #EFEFEF;">
                <h2 style="border-bottom: 0">
                  ATM 이상신고
                  <br />
                  <span>장애내용을 등록해주세요.</span>
                </h2>
                <a class="regist-btn btn-black" style="height: 40px; color: #fff; line-height: 40px;" @click="obstSave">
                  장애신고
                </a>
              </div>
              <div class="form-wrap">
                <div v-if="getRouteAtmInfo" class="atm_name">
                  {{ getRouteAtmInfo.atm_name }}
                </div>
                <dl class="row row_jsb row_ac">
                  <dt>ATM 찾기</dt>
                  <dd class="width50">
                    <input type="text" class="t-input" placeholder="COM 번호를 입력하세요" v-model="obstData.prchChnlAfliNum">
                  </dd>
                  <dd class="btn-wrap">
                    <a class="btn bg-default" @click="findAtmInfo">찾기</a>
                  </dd>
                </dl>
                <div class="info-inp">
                  <input type="text" class="t-input" v-model="obstData.atmInfo" disabled>
                </div>
                <dl class="row row_jsb row_ac">
                  <dt>장애유형</dt>
                  <dd>
                    <select class="t-select" v-model="obstData.atmObstTypeCd">
                      <option value="">선택</option>
                      <optgroup
                        v-for="(grpKeyCdLabel, grpIdx) in atmObstTypeCdsData.key"
                        :key="`grpKeyCdLabel-${grpIdx}`"
                        :label="grpKeyCdLabel"
                      >
                        <option
                          v-for="atmObstType in atmObstTypeCdsData[grpKeyCdLabel]"
                          :key="atmObstType.code"
                          :value="atmObstType.cmnsCd"
                        >
                          {{atmObstType.cmnsCdNm}}
                        </option>
                      </optgroup>
                    </select>
                  </dd>
                </dl>
                <dl v-if="atmObstSmclTypeCds && atmObstSmclTypeCds.length > 0" class="row row_jsb row_ac">
                  <dt>
                    상세유형
                  </dt>
                  <dd>
                    <select class="t-select" v-model="obstData.atmObstSmclTypeCd">
                      <option value="">선택</option>
                      <option
                        v-for="(item, atmObstSmclTypeCdIdx) in atmObstSmclTypeCds"
                        :key="`atmObstSmclTypeCd-${atmObstSmclTypeCdIdx}`"
                        :value="item.atmObstSmclCd"
                      >
                        {{item.atmObstSmclNm}}
                      </option>
                    </select>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>내용</dt>
                  <dd class="h-textarea">
                    <textarea cols="30" rows="10" class="textBox h-100" v-model="obstData.atmObstCtts"></textarea>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>첨부 이미지</dt>
                  <dd class="t-input addfile" >
                    <button type="button" class="btn-file" @click="handleCameraModalOpen">파일선택</button>
                    {{ getFilesNameList.join(', ') }}
                  </dd>
                </dl>
              </div>
            </div>
          </section>
          <div class="btn-wrap">
          </div>
        </article>
      </main>
    </div>
    <Camera @popupComplete="cameraJobDone"/>
  </div>
</template>

<script>
import {
  DxColumn,
  DxDataGrid,
  DxScrolling,
  DxSelection,
  DxStringLengthRule
} from 'devextreme-vue/data-grid'

import Vue from 'vue'
import AppConfig from '@/config'
import DxDateBox from 'devextreme-vue/date-box'
import DxTextBox from 'devextreme-vue/text-box'
import DxTextArea from 'devextreme-vue/text-area'
import DxSelectBox from 'devextreme-vue/select-box'
import {mapGetters} from 'vuex'

import Camera from '@/components/Camera.vue'

export default {
  name: 'AtmObstHstrInsert',
  props: ['propAtmInfo', 'isModal'],
  components: {
    DxColumn,
    DxTextBox,
    DxDateBox,
    DxTextArea,
    DxDataGrid,
    DxScrolling,
    DxSelection,
    DxSelectBox,
    DxStringLengthRule,
    Camera
  },
  data () {
    return {
      prefixUrl: '/api/purchase/customerCare/atmObstHstrInsert',
      obstData: {
        prchChnlAfliNum: '',
        atmInfo: '',
        atmNum: '',
        atmDvsnCd: '',
        atmObstTypeCd: '',
        atmObstStatCd: '',
        atmObstRegCd: '2',
        atmObstCtts: '',
        apndFlInfo: '',
        atmObstSmclTypeCd: ''
      },
      atmObstTypeCds: [],
      atmObstTypeCdsData: {},
      atmStatButton: true,
      files: [],
      atmObstSmclTypeCds: []
    }
  },
  computed: {
    ...mapGetters('Login', {
      userId: 'getUserId'
    }),
    ...mapGetters('LatestMenu', {
      latestMenuList: 'getLatestMenuList',
      current: 'getCurrent'
    }),
    getRouteAtmInfo () {
      if (this.$route.params.atmInfo) {
        return this.$route.params.atmInfo
      } else if (this.propAtmInfo) {
        return this.propAtmInfo
      }
      return null
    },
    getFilesNameList () {
      if (this.files.length > 0) {
        return this.files.map(obj => obj.name)
      }
      return []
    }
  },
  watch: {
    '$route' (to, from) {
      // 초기화 작업
      if (to.name === 'AtmObstHstrInsert') {
        this.init()
      }
    },
    getRouteAtmInfo (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.handleRouteParamAtmInfo(newVal)
      }
    },
    'obstData.atmObstTypeCd': {
      deep: true,
      handler (newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.getAtmObstSmclTypeCd()
        }
      }
    }
  },
  methods: {
    init () {
      this.obstData = {
        prchChnlAfliNum: '',
        atmInfo: '',
        atmNum: '',
        atmDvsnCd: '',
        atmObstTypeCd: '',
        atmObstStatCd: '',
        atmObstRegCd: '2',
        atmObstCtts: '',
        apndFlInfo: ''
      }
    },
    waitForNextAction (timeToDelay) {
      return new Promise((resolve) => setTimeout(resolve, timeToDelay))
    },
    handleRouteParamAtmInfo (atmInfoObj) {
      if (atmInfoObj) {
        this.obstData.prchChnlAfliNum = atmInfoObj.com_num
        this.findAtmInfo()
      }
    },
    async findAtmInfo () {
      if (!this.obstData.prchChnlAfliNum) {
        window.$Alert.alert('COM 번호를 입력하세요~')
        return
      }
      // 기존의 있는 값이 있지 않게 하기 위한 작업
      this.obstData.atmNum = ''

      await Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrBsncnum', {params: { ...this.obstData }})
        .then((response) => {
          if (response && response.data && response.data.result) {
            const prchChnlAfliObj = response.data.result
            if (!prchChnlAfliObj) {
              this.obstData = {...this.obstData, atmNum: '', atmInfo: '', atmDvsnCd: ''}
              window.$Alert.alert('COM 번호를 확인해 주세요!')
              return
            } else {
              this.obstData = {...this.obstData, atmNum: prchChnlAfliObj.atmNum, atmInfo: prchChnlAfliObj.atmInfo, atmDvsnCd: prchChnlAfliObj.atmDvsnCd}
            }
          } else {
            this.obstData = {...this.obstData, atmNum: '', atmInfo: '', atmDvsnCd: ''}
            window.$Alert.alert('COM 번호를 확인해 주세요!')
          }
        })

      if (this.obstData.atmNum == null || this.obstData.atmNum == '') {
        this.obstData = {...this.obstData, atmInfo: '', atmNum: '', atmDvsnCd: '', atmObstStatCd: ''}
        window.$Alert.alert('COM 번호를 확인해 주세요!')
      } else {
        this.findAtmNumStat()
      }
    },
    async findAtmNumStat () {
      // ATM의 장애상태값 초기화 작업
      this.obstData.atmObstStatCd = ''
      // ATM의 상태값 조회
      await Vue.httpClient.get('/api/purchase/customerCare/selectAtmNumStatCheck', {params: { ...this.obstData }})
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            this.obstData.atmObstStatCd = response.data.result[0].atmObstStatCd
          }
          // ATM의 상태가 정상이면 장애신고 버튼 활성화
          if (response.data.result[0].atmStatCd == 1) {
            this.atmStatButton = true
          } else {
            this.atmStatButton = false
          }
        })
    },
    async upload (files) {
      const fd = new FormData()
      files.forEach(file => {
        fd.append('files', file)
      })
      const { data } = await Vue.httpClient.post('/api/purchase/customerCare/imageUpload',
        fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (data.status == '200') {
        return data.result
      } else {
        return ''
      }
    },
    async obstSave () {
      if (!this.obstData.atmNum) {
        window.$Alert.alert('COM 번호를 확인해 주세요.')
        return
      }
      if (!this.obstData.atmObstTypeCd) {
        window.$Alert.alert('장애유형을 선택하세요.')
        return
      }
      if (!this.obstData.atmObstCtts) {
        window.$Alert.alert('장애내용을 입력하세요.')
        return
      }
      if (this.atmObstSmclTypeCds.length > 0 && !this.obstData.atmObstSmclTypeCd) {
        window.$Alert.alert('상세유형을 입력하세요.')
        return
      }
      const confirm = await this.$Alert.confirm('저장 하시겠습니까?')
      if (!confirm) return

      if (this.files && this.files.length > 0) {
        this.obstData.apndFlInfo = await this.upload(this.files)
      }

      Vue.httpClient.post('/api/purchase/customerCare/atmObstHstrInsert', {...this.obstData}, { data: { isToast: 'Y', atmObstRegCd:'2' } })
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            // window.$Alert.alert('장애신고가 등록 되었습니다.')
            this.gotoatmObstHstr()
          }
        })
    },
    gotoatmObstHstr () {
      if (!this.isModal) {
        this.$router.push({name: 'AtmObstHstrMain', params: { }})
      } else {
        this.$emit('jobDone')
      }
    },
    // 아래의 async를 넣지 않으면 에러발생 - 사용하는 장애유형 조회하기
    async setCommCodeByAtmObstTypeCds () {
      const params = {}
      const response = await Vue.httpClient.post('/api/purchase/customerCare/atmObstTypeMngtUseList', params)
      const codeList = []
      this.atmObstTypeCdsData = {}
      this.atmObstTypeCdsData.key = new Set()

      if (response && response.data && response.data.result) {
        response.data.result.forEach(c => {
          let grpKeyCdLabel = ''
          if (c.grpKeyCd === 'D') {
            grpKeyCdLabel = '기기'
          } else if (c.grpKeyCd === 'C') {
            grpKeyCdLabel = '회수'
          } else if (c.grpKeyCd === 'X') {
            grpKeyCdLabel = '기타'
          }
          this.atmObstTypeCdsData.key.add(grpKeyCdLabel)
          if (!this.atmObstTypeCdsData[grpKeyCdLabel]) {
            this.atmObstTypeCdsData[grpKeyCdLabel] = [
              {
                cmnsCd: c.atmObstTypeCd,
                cmnsCdNm: c.atmObstTypeNm,
                guidCtts: c.guidCtts
              }
            ]
          } else {
            this.atmObstTypeCdsData[grpKeyCdLabel] = [
              ...this.atmObstTypeCdsData[grpKeyCdLabel],
              {
                cmnsCd: c.atmObstTypeCd,
                cmnsCdNm: c.atmObstTypeNm,
                guidCtts: c.guidCtts
              }
            ]
          }
          codeList.push({
            cmnsCd: c.atmObstTypeCd,
            atmObstTypeCd: c.atmObstTypeCd,
            cmnsCdNm: c.atmObstTypeNm,
            atmObstTypeNm: c.atmObstTypeNm,
            guidCtts: c.guidCtts,
            grpKeyCdLabel
          })
        })
      }
      this.atmObstTypeCds = [...codeList]

      this.obstData.atmObstTypeCd = ''
    },
    async getAtmObstSmclTypeCd () {
      this.obstData.atmObstSmclTypeCd = ''
      const apiUrl = `/api/purchase/customerCare/getAtmObstSmclTypeCd/${this.obstData.atmObstTypeCd}`
      const res = await this.$http.get(apiUrl)

      if (res) {
        const { data: { result, status } } = res
        if (status === '200') {
          this.atmObstSmclTypeCds = [...result]
          if (result && result.length === 1) {
            this.obstData.atmObstSmclTypeCd = result[0].atmObstSmclCd
          }
        }
      }
    },
    handleCameraModalOpen (e) {
      this.$modal.show('cameraModal', { limitCnt: 5 })
    },
    cameraJobDone (files) {
      this.files = files
    }
  },
  async mounted () {
    this.$store = window.$store
    // 초기화 작업
    this.obstData = []
    // 장애유형 조회하기
    await this.setCommCodeByAtmObstTypeCds()
    await this.$nextTick()

    this.handleRouteParamAtmInfo(this.getRouteAtmInfo)
  }
}
</script>

<style scoped>
.atm_name {
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
  border: 1px solid #E3E3E3;
  border-radius: 5px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmObstHstrInsert.vue